import React from 'react'
import {Input, Select} from 'antd'
import {STATUS, STATUS_LOCK} from "./../../constant/index"

function PhoneNumberFilters(props) {
    const {filters, tenants, listTelco, onChangeFilters} = props

    const _handleInputEnter = (e) => {
        onChangeFilters(e.target.name, e.target.value)
    }

    const _handleSelectChange = (name, value) => {
        onChangeFilters(name, value ? value + '' : '')
    }

    return (
        <div className="CallHistoryFilters Filters">
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Khách hàng</label>
                    <Select
                        showSearch
                        allowClear
                        style={{width: '100%'}}
                        value={filters.tenantId ? parseInt(filters.tenantId) : undefined}
                        placeholder="Chọn khách hàng"
                        optionFilterProp="label"
                        options={tenants}
                        onChange={(value) => _handleSelectChange('tenantId', value)}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Số ảo</label>
                    <Input
                        name="shortPhone"
                        defaultValue={filters.shortPhone || ''}
                        placeholder="Gõ Enter để tìm kiếm"
                        onPressEnter={_handleInputEnter}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Số điện thoại</label>
                    <Input
                        name="phoneNumber"
                        defaultValue={filters.phoneNumber || ''}
                        placeholder="Gõ Enter để tìm kiếm"
                        onPressEnter={_handleInputEnter}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Mạng</label>
                    <Select
                        showSearch
                        allowClear
                        style={{width: '100%'}}
                        value={filters.telco || undefined}
                        placeholder="Chọn mạng"
                        optionFilterProp="label"
                        options={listTelco}
                        onChange={(value) => _handleSelectChange('telco', value)}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Trạng thái</label>
                    <Select
                        showSearch
                        allowClear
                        style={{width: '100%'}}
                        value={filters.status !== undefined ? filters.status : undefined}
                        placeholder="Chọn trạng thái"
                        optionFilterProp="label"
                        options={STATUS}
                        onChange={(value) => _handleSelectChange('status', value)}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Mạng khóa</label>
                    <Select
                        showSearch
                        allowClear
                        style={{width: '100%'}}
                        value={filters.statusLock || undefined}
                        placeholder="Chọn mạng khóa"
                        optionFilterProp="label"
                        options={STATUS_LOCK}
                        onChange={(value) => _handleSelectChange('statusLock', value)}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Brand Name</label>
                    <Input
                        name="brandName"
                        defaultValue={filters.brandName || ''}
                        placeholder="Gõ Enter để tìm kiếm"
                        onPressEnter={_handleInputEnter}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Nguồn</label>
                    <Input
                        name="source"
                        defaultValue={filters.source || ''}
                        placeholder="Gõ Enter để tìm kiếm"
                        onPressEnter={_handleInputEnter}
                    />
                </div>
            </div>
        </div>
    )
}

export default PhoneNumberFilters
